import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ZSHIP_ID } from 'src/constants';

export const checkCreditsBalance = createAsyncThunk(
    'creditsAndSubscription/checkCreditsBalance',
    async (payload, { getState, dispatch }) => {
        const state = getState().entities.creditsAndSubscription;
        const profile = getState().entities.profile?.profile;

        if (ZSHIP_ID.includes(profile?.merchant?.id)) return true;

        if (
            (!state?.subscriptionInfo || state?.subscriptionInfo?.remainingTasksCount <= 0) &&
            (state?.credits === 0 || state?.credits < (state?.subscriptionInfo?.plan?.extraTaskPrice / 100))
        ) {
            dispatch(openCreditsBalancDialog(payload));
            return false;
        }
        return true;
    }
);

const creditsAndSubscription = createSlice({
    name: 'creditsAndSubscription',
    initialState: {
        open: false,
        title: "Warning",
        content: 'There is not enough balance.',
        credits: 0,
        subscriptionInfo: null,
        isShippingCompanyNotHaveEnoughCredits: false,
    },
    reducers: {
        setCredits: (state, action) => {
            state.credits = action?.payload
        },
        setSubscriptionInfo: (state, action) => {
            state.subscriptionInfo = action?.payload
        },
        openCreditsBalancDialog: (state, action) => {
            state.open = true;
            state.title = action?.payload?.title ?? "Warning"
            state.content = action?.payload?.content ?? 'There is not enough balance.'
            state.isShippingCompanyNotHaveEnoughCredits = action?.payload?.isShippingCompanyNotHaveEnoughCredits ?? false
        },
        closeCreditsBalancDialog: (state) => {
            state.open = false;
            state.title = 'Warning'
            state.content = 'There is not enough balance.'
            state.isShippingCompanyNotHaveEnoughCredits = false
        }
    },
});

export const {
    openCreditsBalancDialog,
    closeCreditsBalancDialog,
    setCredits,
    setSubscriptionInfo
} = creditsAndSubscription.actions

export default creditsAndSubscription.reducer